var _path, _rect, _path2, _rect2, _path3, _rect3, _path4, _rect4, _polygon, _polygon2, _polygon3, _polygon4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbbLogoRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#ff000f",
    viewBox: "0 0 86.2 33",
    width: 86.2,
    height: 33,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 33h2c6-.3 10.2-5 10.2-10.6 0-1.9-.4-3.8-1.3-5.3H47V33z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 16,
    x: 36,
    y: 17
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3 16c-1-1.4-2.4-2.5-3.9-3.3 1.8-1.3 3-3.4 3-5.7 0-3.9-3.1-7-7-7H47v16h10.3z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 16,
    x: 36
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74 33h2c6-.3 10.2-5 10.2-10.6 0-1.9-.4-3.8-1.3-5.3H74V33z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 16,
    x: 63,
    y: 17
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3 16c-1-1.4-2.4-2.5-3.9-3.3 1.8-1.3 3-3.4 3-5.7 0-3.9-3.1-7-7-7H74v16h10.3z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 16,
    x: 63
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "5.7,17 0,33 8.3,33 10.7,26 16,26 16,17"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "16,0 11.7,0 6,16 16,16"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "17,26 22.3,26 24.7,33 33,33 27.3,17 17,17"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "27,16 21.3,0 17,0 17,16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbbLogoRed);
export default __webpack_public_path__ + "static/media/abb-logo-red.22f57d1e5a96aa306c6f2b6f122af482.svg";
export { ForwardRef as ReactComponent };